import * as React from 'react'
import { Label, Message } from 'semantic-ui-react'

import useAxios from 'hooks/useAxios'
import { Loader } from 'shared/components/Loader'
import { IntegrationContainer } from 'components/IntegrationContainer'

export default function CyclrMarketplacePage() {
  return (
    <IntegrationContainer>
      <div className="admin-heading">
        <h2>
          Integrations
          <Label size="small" className="green ml2">
            beta
          </Label>
        </h2>
      </div>
      <MarketPlaceIframe />
    </IntegrationContainer>
  )
}

function MarketPlaceIframe() {
  const { data, error } = useAxios({
    url: 'cyclr/marketplace/',
  })

  if (error) {
    return (
      <Message negative>
        <strong>Whoops!</strong> Something went wrong. Please contact Simplesat support to help you
        out.
      </Message>
    )
  }

  const loading = !data
  if (loading) {
    return <Loader withContainer />
  }

  const marketplaceUrl = data?.marketplace_url
  if (marketplaceUrl) {
    const iframe = `<iframe width="100%" height="100%" src=${marketplaceUrl}  frameborder="0" ></iframe>`
    return (
      <div
        className="h-screen"
        dangerouslySetInnerHTML={{
          __html: iframe,
        }}
      />
    )
  }

  return null
}



// WEBPACK FOOTER //
// ./src/pages/Admin/Integrations/Cyclr/Marketplace/index.tsx